<template>
  <div id="app">
    <head-Back title="分享"></head-Back>
    <div  v-if="!iosflag"  class="page">
      <div class="page-button">
        <div class="share-left" @click="shareApp(1)">
          <img src="../../assets/img/toshar-wx.png" />
          <br />
          <button>微信邀请</button>
        </div>
        <div class="share-right" @click="shareApp(2)">
          <img src="../../assets/img/toshare-dx.png" />
          <br />
          <button>短信邀请</button>
        </div>
      </div>
    </div>
     <div v-if="iosflag" class="pageios" >
      <div class="page-button-center">
        <div class="share-right share-center" @click="shareAppaa(2)">
          <img src="../../assets/img/toshare-dx.png" />
          <br />
          <button>短信邀请</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import headBack from "../common/head-back";
import api from "../../api/index";
import wxapi from "../../utils/wxapi";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "管理中心"
  },
  name: "app",
  data() {
    return {
      msg: "注册协议",
      shareConfigdata: null,
      link: "",
      invitationCode: "invitationCode",
      dlink: "",
      iosflag:true
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
   
  },
  created(){
      var ua = navigator.userAgent;
    if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;          
    }else{
      this.iosflag = false;          
    }
  },
  methods: {
    copy(e) {
      console.log(e.text);
      tips.toast("复制成功，快去黏贴分享吧");
    },
    onError(e) {
      console.log(e);
      tips.toast("复制失败");
    },
    shareAppaa(type) {
         // var url ="http%3A%2F%2Fwap.haoyunba.com%2F%23%2FshareNews%3Ftype%3D"+type+"%26shareid%3D"+ userInfo.id;
      var url = ""
      var msg = "你的好友邀请你使用学习乐APP，快去App Store搜索“学习乐”开始你们的亲密聊天。";
      var title = "一个懂事的聊天APP";
        window.location.href =
                "hqml://share?shareType=" +
                type +
                "&message=" +
                msg +
                "&title=&url=" +
                url;
    
    },
    shareApp(type) {

      var userInfo = this.getUserInfo;
      // var url ="http%3A%2F%2Fwap.haoyunba.com%2F%23%2FshareNews%3Ftype%3D"+type+"%26shareid%3D"+ userInfo.id;
      var url = "http%3A%2F%2Fwap.haoyunba.com%2F%23%2FchannelHybShare%2F"+userInfo.channelid+"%2F"+userInfo.id
      var msg = "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐给你用的特殊APP！";
      var title = "一个懂事的聊天APP";
      //http%3A%2F%2Fwap.haoyunba.com%2F%23%2FshareNews%3Ftype%3D1%3F%26shareid%3D1
      if (type == 2) {
        var data = {
          // url:"http://wap.haoyunba.com/#/shareNews?type="+type+"&shareid="+ userInfo.id
           url:"http%3A%2F%2Fwap.haoyunba.com%2F%23%2FchannelHybShare%2F"+userInfo.channelid+"%2F"+userInfo.id

        };

        this.$axiosHttp({
          method: "POST",
          url: api.qml.getdwz,
          data: data
        })
          .then(res => {
            //console.log("发送验证码结果" + JSON.stringify(res));
            if (res.code == 0) {
              console.log(res.result);
              msg =
                "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐的特殊APP！点击 " +
                res.result +
                " 立即使用！";
              window.location.href =
                "hqml://share?shareType=" +
                type +
                "&message=" +
                msg +
                "&title=&url=" +
                url;
            } else {
              tips.toast(res.message);
            }
          })
          .catch(err => {
            tips.toast(err);
            console.log(err);
          });
      } else {
        window.location.href =
          "hqml://share?shareType=" +
          type +
          "&message=" +
          msg +
          "&title=" +
          title +
          "&url=" +
          url;
      }
    },
    toshareWx() {
      var data = this.shareConfigdata;
    },
    share() {
      var msg = "你我的亲密空间";
      if (num == 2) {
        msg = "你的好友邀请你使用亲密聊APP，点击立即开始你们的亲密聊天";
      }
      //获取微信data数据，分享数据
      let url = window.location.href;
      this.link = url;
      var data = {
        url: this.link
      };
      this.$axiosHttp({
        method: "POST",
        url: api.qml.wxgetShareConfig,
        data: data
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            console.log(res.result);
            this.shareConfigdata = res.result;
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });

      var userInfo = this.getUserInfo;
      this.invitationCode =
        window.location.host + "/#/shareNews/1/" + userInfo.id;
      console.log(this.invitationCode);
      let opstion = {
        title: "一个懂事的聊天APP", // 分享标题
        link: window.location.href,
        imgUrl: "../../assets/img/logo-hyb.png", // 分享图标
        dec: "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐给你用的特殊APP！",
        success: function() {},
        error: function() {}
      };
      wxapi.wxRegister(this.shareConfigdata, option);
    },
    toShareDx() {
      var phone = "";
      //发送短信的内容
      var name = "分享至";
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      var isiOS =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1; //ios终端
      if (isAndroid) {
        var sendcontent = "sms:" + phone + "?body=" + name; //android  ///
        window.location.href = sendcontent;
      } else if (isiOS) {
        var sendcontent = "sms:" + phone + "&body=" + name; //ios  ///
        window.location.href = sendcontent;
      } else {
        var sendcontent = "sms:" + phone + "?body=" + name; //android  ///
        window.location.href = sendcontent;
      }
    }
  },
  components: {
    headBack
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1574px;
  background: url("../../assets/img/toshareNews-back-ios.png");
  background-size: 100% 100%;
}
.pageios{
  width: 750px;
  height: 1574px;
  background: url("../../assets/img/toshareNews-back-ios.png");
  background-size: 100% 100%;
}



.share-left,
.share-right {
  width: 157px;
  height: 200px;
  float: left;
  margin-top: 1000px;
}

.share-left {
  margin-left: 155px;
}
.share-right {
  margin-left: 152px;
}

.share-center{
  margin: 1000px 0 0 300px;
}
.share-left img,
.share-right img {
  width: 90px;
  height: 90px;
}

.share-left button,
.share-right button {
  width: 157px;
  height: 55px;
  background: #3A00E2;
  border-radius: 28px;
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 55px;
  border: none;
  margin: 15px 0 0 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/toshareNews.vue